import React from "react";

export default function GamesComponent({ gamesList = [], teamId }) {
  if (!gamesList.length) return <p>No games scheduled.</p>;

  // Sort games by date (oldest to newest)
  const sortedGames = [...gamesList].sort(
    (a, b) => new Date(a.date) - new Date(b.date)
  );

  return (
    <ul className="space-y-2">
      {sortedGames.map((g) => {
        const isHome = g.home_team_id === teamId;
        const teamScore = isHome ? g.home_score : g.away_score;
        const opponentScore = isHome ? g.away_score : g.home_score;
        const opponent = isHome ? g.away_team : g.home_team;

        const teamWins = teamScore > opponentScore;
        const opponentWins = opponentScore > teamScore;

        return (
          <li
            key={g.id}
            className="p-2 border rounded shadow-sm flex justify-between items-center"
          >
            <span>
              <span className="text-gray-500">{g.date}</span>{" -- "}
              <span className={teamWins ? "font-bold" : ""}>
                {isHome ? g.home_team : g.away_team}
              </span>{" "}
              {isHome ? "vs" : "at"}{" "}
              <span className={opponentWins ? "font-bold" : ""}>{opponent}</span>{"---"}
            </span>
            <span className="font-semibold">
              {teamScore}:{opponentScore}
            </span>
          </li>
        );
      })}
    </ul>
  );
}
